import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { ModelWithFile } from "@/frontend/typings/types";
import { useEffect } from "react";
import { Card } from "react-bootstrap";

export function CardImage(props: { model: ModelWithFile, fileSourceUrl: string | undefined, setFileSourceUrl: (url: string) => void }) {
  const { model, fileSourceUrl, setFileSourceUrl } = props;
  const getFileSourceUrl = useGlobalStore(state => state.getFileSourceUrl);

  useEffect(() => {
    if (model.file?.id) {
      void getFileSourceUrl(model.file.id).then(response => {
        if (response.status === 200) {
          setFileSourceUrl(response.downloadUrl);
        }
      });
    }
  }, [model.file]);

  return (
    <Card.Img 
      className={`border rounded border-secondary w-100 ${fileSourceUrl ? 'opacity-100' : 'opacity-50'}`}
      style={{ objectFit: `${fileSourceUrl ? 'cover' : 'contain'}`, height: '200px' }}
      variant="top"
      alt={model.file?.fileName}
      src={fileSourceUrl || '/images/diode.svg'} 
    />
  );
}